<div
  class="row section-row section clinical-feedback-section mt-3"
  formGroupName="advisedSeriousIncident"
  *ngIf="showForm"
>
  <div class="section-container">
    <app-confirmed-serious-incident-form
      [seriousIncidentType]="feedbackForm['seriousIncidentType'].value"
      *ngIf="showConfirmedSeriousIncident"
    >
    </app-confirmed-serious-incident-form>
    <app-duty-of-candour-form
      [accessionNumber]="accessionNumber"
      [region]="region"
      *ngIf="showDutyOfCandourForm"
    ></app-duty-of-candour-form>
    <app-regulatory-investigations-form
      *ngIf="showRegulatoryInvestigationsForm"
    ></app-regulatory-investigations-form>
    <app-other-form *ngIf="showOtherForm"></app-other-form>
  </div>
</div>
